<template>
  <div>
    <index-chart v-if="indexStyle==1"></index-chart>
    <index-bdc v-if="indexStyle==2"></index-bdc>

    <div>
<!--      当前构建版本：{{ process.env.VUE_APP_VERSION }}-->
    </div>

    <div style="width: 100%;text-align: right;margin-top: 10px;height:20px;">
      图表类型：
      <a-radio-group v-model="indexStyle">
        <a-radio :value="1">公司统计图表</a-radio>
        <a-radio :value="2">部门统计图表</a-radio>
      </a-radio-group>
    </div>
  </div>
</template>

<script>
  import IndexChart from './IndexChart'
  import IndexBdc from './IndexBdc'

  export default {
    name: "Analysis",
    components: {
      IndexChart,
      IndexBdc
    },
    data() {
      return {
        indexStyle:1
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>